import { Button, Input, Stack } from '@chakra-ui/react';
import { Show } from '@pelicargo/ui';
import { useState } from 'react';

import { useCurrentDraft } from '../../hooks/useCurrentDraft';

/**
 * Sticky footer with apply/discard/delete. Owns the confirm mini-flows; the parent remounts this (key={draft.id}) so
 * the flows reset when the draft changes.
 */
export const DraftActionBar = () => {
  const { draft, isPending, applyPlan, isApplying, applyDraft, isDiscarding, isDeleting, discardDraft, deleteDraft } =
    useCurrentDraft();

  const [showDiscardReason, setShowDiscardReason] = useState(false);
  const [discardReason, setDiscardReason] = useState('');
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showApplyConfirm, setShowApplyConfirm] = useState(false);

  const isDeletable = !!draft && !draft.is_actionable;
  const fillCount = applyPlan?.isEligible ? applyPlan.fills.length : 0;
  const isApplicable = isPending && fillCount > 0;
  // No confirmation step is open, so the primary actions are the ones to show.
  const isIdle = !showDiscardReason && !showDeleteConfirm && !showApplyConfirm;

  return (
    <Stack px="5" py="3" borderTopWidth="1px" bg="chakra-body-bg" spacing="3">
      <Show if={showDiscardReason}>
        <Input
          placeholder="Discard reason (optional)"
          value={discardReason}
          onChange={(e) => setDiscardReason(e.target.value)}
        />
      </Show>
      <Stack direction="row" spacing="2" justifyContent="flex-end">
        <Show if={isIdle && isDeletable}>
          <Button variant="outline" colorScheme="red" onClick={() => setShowDeleteConfirm(true)}>
            Delete
          </Button>
        </Show>

        <Show if={isIdle && isApplicable}>
          <Button colorScheme="purple" onClick={() => setShowApplyConfirm(true)}>
            Apply {fillCount} flight{fillCount === 1 ? '' : 's'}
          </Button>
        </Show>

        <Show if={showApplyConfirm}>
          <Button variant="ghost" onClick={() => setShowApplyConfirm(false)}>
            Cancel
          </Button>
          <Button
            colorScheme="purple"
            isLoading={isApplying}
            onClick={async () => {
              await applyDraft();
              setShowApplyConfirm(false);
            }}
          >
            Confirm — fill {fillCount} blank leg{fillCount === 1 ? '' : 's'}
          </Button>
        </Show>

        <Show if={showDeleteConfirm}>
          <Button variant="ghost" onClick={() => setShowDeleteConfirm(false)}>
            Cancel
          </Button>
          <Button colorScheme="red" onClick={deleteDraft} isLoading={isDeleting}>
            Confirm Delete
          </Button>
        </Show>

        <Show if={isIdle}>
          <Button colorScheme="gray" onClick={() => setShowDiscardReason(true)}>
            Discard
          </Button>
        </Show>

        <Show if={showDiscardReason}>
          <Button variant="ghost" onClick={() => setShowDiscardReason(false)}>
            Cancel
          </Button>
          <Button colorScheme="red" onClick={() => discardDraft(discardReason)} isLoading={isDiscarding}>
            Confirm Discard
          </Button>
        </Show>
      </Stack>
    </Stack>
  );
};
